// imove-behavior: 检查登录状态

export default async function(ctx) {
  const { checkLogin } = ctx.payload;
  if (checkLogin) {
    try {
      const res = await checkLogin();
      return {
        status: 'success',
        data: res,
      }
    } catch(err) {
      return {
        status: 'err',
        data: err,
      }
    }
  }
  return {
    status: 'no func',
    data: null,
  }
}